import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';

// Applicants table data
export const ResponseData = [
  {
    id: 1,
    first_name: 'John',
    last_name: 'Doe',
    full_name: 'John Doe',
    interview_status: 'Not Scheduled',
    position: 12,
    experience: '5 Years',
    ctc: '10 LPA',
    expected_ctc: '14 LPA',
    skills: [{ skill: 'PHP' }, { skill: 'Laravel' }],
    notice_period: '30 days',
    date_of_joining: '10 May 2021',
    source: 'Amazon',
  },
  {
    id: 2,
    first_name: 'John',
    last_name: 'Doe',
    full_name: 'John Doe',
    interview_status: 'Not Scheduled',
    position: 15,
    experience: '5 Years',
    ctc: '12 LPA',
    expected_ctc: '14 LPA',
    skills: [{ skill: 'PHP' }, { skill: 'Laravel' }, { skill: 'React' }],
    notice_period: '30 days',
    date_of_joining: '10 May 2021',
    source: 'Wipro',
  },
];

// Applicants table header
export const PositionHead = [
  { label: 'id', key: 'id', hide: true, type: 'text', headClass: ' ', bodyClass: '' },
  {
    label: 'Full Name',
    key: 'full_name',
    hide: false,
    type: 'text',
    headClass: 'w-150 ',
    bodyClass: '',
  },
  {
    label: 'Interview Status',
    key: 'interview_status',
    hide: false,
    headClass: 'w-200',
    type: 'text',
  },
  { label: 'Position', key: 'position', hide: false, type: 'text', headClass: 'w-150' },
  {
    label: 'Years of Experience',
    key: 'experience',
    hide: false,
    type: 'text',
    headClass: 'w-200',
    bodyClass: '',
  },
  { label: 'CTC', key: 'ctc', hide: false, type: 'text', headClass: 'w-150' },
  { label: 'Expected CTC', key: 'expected_ctc', hide: false, type: 'text', headClass: 'w-150' },
  {
    label: 'Skills',
    key: 'skills',
    hide: false,
    type: 'array',
    keys: [{ key: 'skill', hide: false, arrayClass: 'badge-outlined badge-warning' }],
    headClass: 'w-200',
    bodyClass: '',
  },
  {
    label: 'Notice Period',
    key: 'notice_period',
    hide: false,
    type: 'text',
    headClass: 'w-200',
    bodyClass: '',
  },
  {
    label: 'Date of Joining',
    key: 'date_of_joining',
    hide: false,
    type: 'text',
    headClass: 'w-200',
    bodyClass: '',
  },
  { label: 'Source', key: 'source', hide: false, type: 'text', headClass: 'w-150', bodyClass: '' },
  {
    label: 'Action',
    key: 'actions',
    hide: false,
    type: 'actions',
    headClass: 'w-200 action-head',
    actions: [
      {
        bodyClass: 'icon-success',
        type: 'edit',
        icon: EditIcon,
        text: 'Edit',
        url: '',
        actionClass: 'icon-wrapper',
      },
      {
        bodyClass: 'icon-warning',
        type: 'open',
        icon: GetAppIcon,
        text: 'Open CV',
        url: '',
        actionClass: 'icon-wrapper',
      },
      {
        bodyClass: 'icon-danger',
        type: 'delete',
        icon: DeleteIcon,
        text: 'Delete',
        url: '',
        actionClass: 'icon-wrapper',
      },
    ],
  },
];

// page header, title, breadcrumb and button
export const PageHeader = {
  className: 'page-header',
  page_title: 'Applicants',
  button: { text: 'Create Applicant', className: 'link-button btn-sm btn-primary', url: '/applicants/create'},
  breadcrumb: [
    { text: 'Dashboard', link: '/dashboard', className: '' },
    { text: 'Applicants', link: '', className: 'active' },
  ],
};

// Applicants Filter data
export const MainFilter = {
  filterClass: '',
  list: [
    {
      label: 'Search',
      placeholder: 'Search',
      variant: 'outlined',
      formControlClass: 'filter-formControl',
      fieldClass: 'textBoxStyle',
      margin: 'dense',
      hide: false,
      type: 'text',
    },
    {
      label: 'Interview Status',
      placeholder: 'Status',
      formControlClass: 'filter-formControl',
      fieldClass: 'textBoxStyle',
      variant: 'outlined',
      margin: 'dense',
      hide: false,
      type: 'multiselect',
    },
    {
      label: 'Skills',
      placeholder: 'Skills',
      variant: 'outlined',
      formControlClass: 'filter-formControl',
      fieldClass: 'textBoxStyle',
      margin: 'dense',
      hide: false,
      type: 'autocomplete',
      size: 'small',
    },
    {
      label: 'Source',
      placeholder: 'Source',
      variant: 'outlined',
      formControlClass: 'filter-formControl',
      fieldClass: 'textBoxStyle',
      margin: 'dense',
      hide: false,
      type: 'text',
    },
  ],
};

// Interview status
export const InterviewStatus = [
  { label: 'Scheduled', key: 'scheduled', value: 'Scheduled' },
  { label: 'Not Scheduled', key: 'not_scheduled', value: 'Not Scheduled' },
  { label: 'Completed', key: 'completed', value: 'Completed' },
  { label: 'Await', key: 'await', value: 'Await' },
];

// skills data
export const SkillsData = [
  { label: 'PHP', title: 'PHP', key: 'php', value: 'PHP' },
  { label: 'Laravel', title: 'Laravel', key: 'laravel', value: 'Laravel' },
  { label: 'React JS', title: 'React JS', key: 'react', value: 'React JS' },
  { label: 'Angular', title: 'Angular', key: 'angular', value: 'Angular' },
  { label: 'CodeIgniter', title: 'CodeIgniter', key: 'codeigniter', value: 'CodeIgniter' },
  { label: 'Python', title: 'Python', key: 'python', value: 'Python' },
  { label: 'Node JS', title: 'Node.js', key: 'node', value: 'Node JS' },
];

// Tabs data
export const Tabs = {
  tabClass: 'dashboard-tab',
  list: [
    { label: 'Create Applicant', key: 'create', link: '/applicants/create', className: 'tab-link' },
    {
      label: 'Edit Applicant',
      key: 'edit',
      link: '/applicants/edit/:id',
      path: '/applicants/edit/:id',
      className: 'tab-link',
    },
    {
      label: 'View Applicant',
      key: 'view',
      link: '/applicants/view/:id',
      path: '/applicants/view/:id',
      className: 'tab-link',
    },
    { label: 'Applicants', key: 'applicants', link: '/applicants', className: 'tab-link' },
  ],
};
